import React from 'react'
import { H6, P } from '../../components/Typography'
import styled from 'styled-components'
import { Container as Cont, Row, Col, media } from 'styled-bootstrap-grid'
import { rem } from '../../styles/Mixins'
import { Button as btn } from '../../components'
import { TabList, Tabs, TabPanel, Tab } from '../../components/Tabs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons'
import { ImpactPanelBg } from '../../assets/svgs'
import { withNullErrorBoundary } from '../../utils/withNullErrorBoundary'
import getImage from '../../utils/getImage'

const Section = styled.section`
  background-color: ${(props) => props.theme.colors.white};
  margin: 0 0 ${rem(50)};
  position: relative;
  z-index: 1;

  ${media.xl`
    max-width: 1920px;
    margin: 0 auto ${rem(130, 'xxxl')};

    :after {
      content: url(${ImpactPanelBg});
      position: absolute;
      left: -100px;
      bottom: -180px;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: left center;
    }
  `}

  ${(props) => props.theme.media.xxxl`
    margin-top: -45px;
  `}
`

const Container = styled(Cont)`
  ${media.xl`
    padding: 0;
    max-width: ${(props) =>
      props.theme.settings.container_horizontal_maxWidth_xl};
  `}

  ${media.xxl`
    max-width: ${(props) =>
      props.theme.settings.container_horizontal_maxWidth_xxl};
  `}

  @media (min-width: 1920px) {
    max-width: 1348px;
  }
`

const ColTabsStyled = styled(Col)`
  ${media.lg`
    order: 1;
  `}
`

const ColContStyled = styled(Col)`
  ${media.lg`
    order: 2;
  `}
`

const TabSection = styled(Tabs)`
  ${media.lg`
    padding-right: 50px;
  `}

  ${media.xl`
    max-width: 818px;
    padding-right: 0;
  `}
`

const ContentSection = styled.div`
  margin-bottom: 58px;
  text-align: center;

  ${media.lg`
    text-align: left;
    margin-bottom: 0;
    margin-top: 80px;
  `}

  ${media.xl`
    margin-left: 80px;
    padding-right: 40px;
  `}
`

const Button = styled(btn)`
  padding: ${rem(13)} ${rem(20)};

  ${media.xl`
    padding: ${rem(8, 'xxxl')} ${rem(20, 'xxxl')} ${rem(11, 'xxxl')};
  `}
`

// tab navgation styled components

const TabItemWrapper = styled(TabPanel)`
  opacity: 0;
  transition: all 0.2s ease-in-out;

  &.is-selected {
    opacity: 1;

    ${media.lg`
      min-height: 380px;
    `}
  }

  ${Col} {
    display: flex;
  }
`

const TabItem = styled.div`
  background-color: ${(props) => props.theme.colors.grey_500};
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  border-radius: 0px 15px;
  padding: 13px 0;
  width: 100%;
  max-width: 500px;
  margin: 0 auto 5px;
  min-height: 80px;

  ${media.md`
    margin-right: 5px;
    min-height: 88px;
    padding: 15px 0;
  `}

  ${media.lg`
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 27px 50px 12px 50px;
    flex-wrap: wrap;
    max-width: 100%;
    min-height: 180px;
    border-radius: 0px 25px;
  `}

  ${media.xl`
    padding: 27px 50px 12px 50px;
  `}

  @media (min-width: 1600px) {
    padding: 27px 70px 12px 62px;
  }
`

const TabItemImgWrapper = styled.div`
  flex: 0 0 8%;

  ${media.lg`
    flex: 0 0 32%;
  `}

  ${media.xl`
    flex: 0 0 32%;
  `}
`

const TabItemImg = styled.img`
  width: 30px;

  ${media.lg`
    width: ${rem(35)};
  `}

  ${media.xl`
    width: ${rem(45, 'xxxl')};
  `}
`

const TabItemNumber = styled.span`
  font-family: 'foco_cc_black', sans-serif;
  color: ${(props) => props.theme.colors.primary};
  font-size: ${rem(26)};
  flex: 0 0 25%;

  ${media.lg`
    flex: auto;
  `}

  ${media.xl`
    font-size: ${rem(44, 'xxxl')};
  `}
`

const TabItemText = styled.p`
  font-family: 'foco_cc_italic', sans-serif;
  color: ${(props) => props.theme.colors.grey};
  font-size: ${rem(12)};
  flex: 0 0 46%;

  ${media.lg`
    flex: 100%;
  `}

  ${media.xl`
  font-size: ${rem(18, 'xxxl')};
  `}
`

//content related styles
const ContentHeading = styled(H6)`
  color: ${(props) => props.theme.colors.primary};
`

const ContentParagraph = styled(P)`
  color: ${(props) => props.theme.colors.grey};
  margin: 0;
  margin-bottom: 28px;

  ${media.xl`
    margin-bottom: ${rem(42, 'xxxl')};
  `}
`

const ImpactPanels = (props) => {
  return (
    <Section>
      <Container>
        <Row alignItems="center">
          <ColContStyled col={12} lg={4} xl={5}>
            <ContentSection>
              <ContentHeading>{props?.heading}</ContentHeading>
              <ContentParagraph>{props?.subtitle}</ContentParagraph>
              {props.has_link ? (
                <Button href={props?.button_link}>{props?.button_text}</Button>
              ) : null}
            </ContentSection>
          </ColContStyled>
          <ColTabsStyled col={12} lg={8} xl={7}>
            <TabSection
              selectedTabClassName="is-selected"
              selectedTabPanelClassName="is-selected"
            >
              <TabList>
                {props?.tabs?.map((tab) => {
                  return (
                    <Tab key={`tablist-${tab?.tabTitle}`}>
                      {tab.tabTitle}
                      <span>
                        <FontAwesomeIcon icon={faAngleDown} />
                      </span>
                    </Tab>
                  )
                })}
              </TabList>
              {props?.tabs?.map((tab) => {
                return (
                  <TabItemWrapper key={`impacttabitems-${tab?.tabTitle}`}>
                    <Row>
                      {tab?.impactCards?.map((card) => {
                        return (
                          <Col
                            col={12}
                            md={6}
                            lg={6}
                            xl={6}
                            key={`impactcard-${tab?.tabTitle}-${card?.impactText}`}
                          >
                            <TabItem>
                              <TabItemImgWrapper>
                                <TabItemImg
                                  src={getImage(
                                    card?.impactIcon?.localFile,
                                    'fluid'
                                  )}
                                  alt=""
                                />
                              </TabItemImgWrapper>
                              <TabItemNumber>{card?.cardMetric}</TabItemNumber>
                              <TabItemText>{card?.impactText}</TabItemText>
                            </TabItem>
                          </Col>
                        )
                      })}
                    </Row>
                  </TabItemWrapper>
                )
              })}
            </TabSection>
          </ColTabsStyled>
        </Row>
      </Container>
    </Section>
  )
}

export default withNullErrorBoundary(ImpactPanels)
